import { doAjax } from './helper'
import { getInteriorImageForStoredComponent} from './imagesLogicController'
import { saveStateWithAjax, getPackageImageSource, checkKey, checkSubmit } from './screen-package-selection-global'

function checkSeatsAndSteeringWheelBadges_rsq8() {
	const imgSource = 'img/01_interieur/paketauswahl/au513_e-tron_gt_paketauswahl_rs_badges_zierleiste.png'
}

function addListeners_rsq8(frontCheckboxesMap, modalsCheckboxesMap) {

	//Basisbild austauschen
	if (frontCheckboxesMap['YVE_RSQ8'].checked == true) {		
		document.getElementById("front_background_image").src="img/06_paketauswahl/q7q8/paketauswahl/au53x_sport-plus_wabe_q4q_yve_frt_basis.png";
	} else {
		document.getElementById("front_background_image").src="img/06_paketauswahl/q7q8/paketauswahl/au53x_paketauswahl_rsq8-iks.png";
	}
	//Basisbild austauschen

	frontCheckboxesMap['YZ1_Q7Q8'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YZ1_Q7Q8',this.checked)
		checkLocks_rsq8(frontCheckboxesMap)
		getPackageImages_rsq8('YZ1_Q7Q8', frontCheckboxesMap)
	})

	frontCheckboxesMap['YSJ_Q7Q8'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YSJ_Q7Q8',this.checked)
		checkLocks_rsq8(frontCheckboxesMap)
		getPackageImages_rsq8('YSJ_Q7Q8', frontCheckboxesMap)
	})
		
	frontCheckboxesMap['YVU_Q7Q8'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YVU_Q7Q8', this.checked);
		if (this.checked) {
			//If we dont come from the modal
			if (frontCheckboxesMap['YVQ'].checked == false) { 
				frontCheckboxesMap['YVQ'].disabled = true
			}
			if (frontCheckboxesMap['YVE_RSQ8'].checked == false) { 
				frontCheckboxesMap['YVE_RSQ8'].disabled = true
			}
		} else {
			checkLocks_rsq8(frontCheckboxesMap)
		}
		getPackageImages_rsq8('YVU_Q7Q8', frontCheckboxesMap)
	})

	frontCheckboxesMap['YVQ'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YVQ', this.checked);
		if (this.checked) {
			//If we dont come from the modal
			if (frontCheckboxesMap['YVU_Q7Q8'].checked == false) { 
				frontCheckboxesMap['YVU_Q7Q8'].disabled = true
			}
			if (frontCheckboxesMap['YVE_RSQ8'].checked == false) { 
				frontCheckboxesMap['YVE_RSQ8'].disabled = true
			}
		} else {
			checkLocks_rsq8(frontCheckboxesMap)
		}
		getPackageImages_rsq8('YVQ', frontCheckboxesMap)
	})	

	frontCheckboxesMap['YTA_Q7Q8'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YTA_Q7Q8', this.checked);
		checkLocks_rsq8(frontCheckboxesMap)
		getPackageImages_rsq8('YTA_Q7Q8', frontCheckboxesMap)
	})
	
	/*
	frontCheckboxesMap['YXP'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YXP', this.checked);
		checkLocks_rsq8(frontCheckboxesMap)
		getPackageImages_rsq8('YXP', frontCheckboxesMap)
	})
	*/
	
	/*
	frontCheckboxesMap['YVZ'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YVZ', this.checked);
		checkLocks_rsq8(frontCheckboxesMap)
		getPackageImages_rsq8('YVZ', frontCheckboxesMap)
		

		//CheckModalVisibility
		const modal = document.querySelectorAll('.modal')[0]
		if (this.checked) {
			modal.classList.remove("hidden")
		} else {
			modal.classList.add("hidden")
		}
		
	})
	*/
	
	frontCheckboxesMap['YTY'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YTY', this.checked);
		checkLocks_rsq8(frontCheckboxesMap)
		getPackageImages_rsq8('YTY', frontCheckboxesMap)
	})
	
	frontCheckboxesMap['YTO_Q7Q8'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YTO_Q7Q8', this.checked);
		if (this.checked) {
			//If we dont come from the modal
			if (frontCheckboxesMap['YTQ_Q7Q8'].checked == false) { 
				frontCheckboxesMap['YTQ_Q7Q8'].disabled = true
			}
			if (frontCheckboxesMap['YVE_RSQ8'].checked == false) { 
				frontCheckboxesMap['YVE_RSQ8'].disabled = true
			}
		} else {
			checkLocks_rsq8(frontCheckboxesMap)
		}
		getPackageImages_rsq8('YTO_Q7Q8', frontCheckboxesMap)
	})

	frontCheckboxesMap['YTQ_Q7Q8'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YTQ_Q7Q8', this.checked);
		if (this.checked) {
			//If we dont come from the modal
			if (frontCheckboxesMap['YTO_Q7Q8'].checked == false) { 
				frontCheckboxesMap['YTO_Q7Q8'].disabled = true
			}
			if (frontCheckboxesMap['YVE_RSQ8'].checked == false) { 
				frontCheckboxesMap['YVE_RSQ8'].disabled = true
			}
		} else {
			checkLocks_rsq8(frontCheckboxesMap)
		}
		getPackageImages_rsq8('YTQ_Q7Q8', frontCheckboxesMap)
	})

	frontCheckboxesMap['YSR_Q7Q8'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YSR_Q7Q8', this.checked);
		if (this.checked) {
			//If we dont come from the modal
			if (frontCheckboxesMap['YTU_Q7Q8'].checked == false) { 
				frontCheckboxesMap['YTU_Q7Q8'].disabled = true
			}
			if (frontCheckboxesMap['YVE_RSQ8'].checked == false) { 
				frontCheckboxesMap['YVE_RSQ8'].disabled = true
			}
            
		} else {
			checkLocks_rsq8(frontCheckboxesMap)
		}
		getPackageImages_rsq8('YSR_Q7Q8', frontCheckboxesMap)
	})	
	
	frontCheckboxesMap['YTU_Q7Q8'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YTU_Q7Q8', this.checked);
		if (this.checked) {
			//If we dont come from the modal
			if (frontCheckboxesMap['YSR_Q7Q8'].checked == false) { 
				frontCheckboxesMap['YSR_Q7Q8'].disabled = true
			}
			if (frontCheckboxesMap['YVE_RSQ8'].checked == false) { 
				frontCheckboxesMap['YVE_RSQ8'].disabled = true
			}
		} else {
			checkLocks_rsq8(frontCheckboxesMap)
		}
		getPackageImages_rsq8('YTU_Q7Q8', frontCheckboxesMap)
	})	

	frontCheckboxesMap['YVE_RSQ8'].addEventListener('change', function () {
		
		//Basisbild austauschen
		if (frontCheckboxesMap['YVE_RSQ8'].checked == true) {		
			document.getElementById("front_background_image").src="img/06_paketauswahl/q7q8/paketauswahl/au53x_sport-plus_wabe_q4q_yve_frt_basis.png";
		} else {
			document.getElementById("front_background_image").src="img/06_paketauswahl/q7q8/paketauswahl/au53x_paketauswahl_rsq8-iks.png";
		}
		//Basisbild austauschen

		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YVE_RSQ8', this.checked);
		if (this.checked) {
			//If we dont come from the modal
			if (frontCheckboxesMap['YZ1_Q7Q8'].checked == false) { 
				frontCheckboxesMap['YZ1_Q7Q8'].disabled = true
			}
			if (frontCheckboxesMap['YTY'].checked == false) { 
				frontCheckboxesMap['YTY'].disabled = true
			}
			if (frontCheckboxesMap['YSJ_Q7Q8'].checked == false) { 
				frontCheckboxesMap['YSJ_Q7Q8'].disabled = true
			}
			if (frontCheckboxesMap['YVU_Q7Q8'].checked == false) { 
				frontCheckboxesMap['YVU_Q7Q8'].disabled = true
			}
			if (frontCheckboxesMap['YVQ'].checked == false) { 
				frontCheckboxesMap['YVQ'].disabled = true
			}
			if (frontCheckboxesMap['YTO_Q7Q8'].checked == false) { 
				frontCheckboxesMap['YTO_Q7Q8'].disabled = true
			}
			if (frontCheckboxesMap['YTQ_Q7Q8'].checked == false) { 
				frontCheckboxesMap['YTQ_Q7Q8'].disabled = true
			}
			if (frontCheckboxesMap['YSR_Q7Q8'].checked == false) { 
				frontCheckboxesMap['YSR_Q7Q8'].disabled = true
			}
			if (frontCheckboxesMap['YTU_Q7Q8'].checked == false) { 
				frontCheckboxesMap['YTU_Q7Q8'].disabled = true
			}
		} else {
			checkLocks_rsq8(frontCheckboxesMap)
		}
		getPackageImages_rsq8('YVE_RSQ8', frontCheckboxesMap)
	})	

}

/**Controls frontcheckboxes disable */
function checkLocks_rsq8(frontCheckboxesMap) {
	//DEFINE UNLOCK CONDITIONS
	
	const unlockConditionForYSJ_Q7Q8 = !frontCheckboxesMap['YVE_RSQ8'].checked
	const unlockConditionForYZ1Q7Q8 = !frontCheckboxesMap['YVE_RSQ8'].checked
	const unlockConditionForYTY = !frontCheckboxesMap['YVE_RSQ8'].checked
	const unlockConditionForYVU_Q7Q8 = !frontCheckboxesMap['YVQ'].checked && !frontCheckboxesMap['YVE_RSQ8'].checked
	const unlockConditionForYVQ = !frontCheckboxesMap['YVU_Q7Q8'].checked && !frontCheckboxesMap['YVE_RSQ8'].checked
	const unlockConditionForYSR_Q7Q8 = !frontCheckboxesMap['YTU_Q7Q8'].checked && !frontCheckboxesMap['YVE_RSQ8'].checked
	const unlockConditionForYTU_Q7Q8 = !frontCheckboxesMap['YSR_Q7Q8'].checked && !frontCheckboxesMap['YVE_RSQ8'].checked
	//const unlockConditionForYSQ_Q7Q8 = !frontCheckboxesMap['YSR_Q7Q8'].checked && !frontCheckboxesMap['YTU_Q7Q8'].checked
	const unlockConditionForYTQ_Q7Q8 = !frontCheckboxesMap['YTO_Q7Q8'].checked && !frontCheckboxesMap['YVE_RSQ8'].checked
	const unlockConditionForYTO_Q7Q8 = !frontCheckboxesMap['YTQ_Q7Q8'].checked && !frontCheckboxesMap['YVE_RSQ8'].checked
	//const unlockConditionForYVZ = true


	const unlockConditionForYVE_RSQ8 = 	!frontCheckboxesMap['YZ1_Q7Q8'].checked && 	!frontCheckboxesMap['YTY'].checked && 	!frontCheckboxesMap['YSJ_Q7Q8'].checked && 	!frontCheckboxesMap['YVU_Q7Q8'].checked && 	!frontCheckboxesMap['YVQ'].checked &&	!frontCheckboxesMap['YTO_Q7Q8'].checked && 	!frontCheckboxesMap['YTQ_Q7Q8'].checked && 	!frontCheckboxesMap['YSR_Q7Q8'].checked && 	!frontCheckboxesMap['YTU_Q7Q8'].checked

	
	//UPDATE VARS 
	//frontCheckboxesMap['YSN'].disabled = !unlockConditionForYSN
	frontCheckboxesMap['YSJ_Q7Q8'].disabled = !unlockConditionForYSJ_Q7Q8
	
	//frontCheckboxesMap['YVK'].disabled = !unlockConditionForYVK
	frontCheckboxesMap['YVU_Q7Q8'].disabled = !unlockConditionForYVU_Q7Q8
	frontCheckboxesMap['YVQ'].disabled = !unlockConditionForYVQ
	frontCheckboxesMap['YSR_Q7Q8'].disabled = !unlockConditionForYSR_Q7Q8
	frontCheckboxesMap['YTU_Q7Q8'].disabled = !unlockConditionForYTU_Q7Q8
	//frontCheckboxesMap['YSQ_Q7Q8'].disabled = !unlockConditionForYSQ_Q7Q8

	frontCheckboxesMap['YTQ_Q7Q8'].disabled = !unlockConditionForYTQ_Q7Q8
	frontCheckboxesMap['YTO_Q7Q8'].disabled = !unlockConditionForYTO_Q7Q8
	//frontCheckboxesMap['YVZ'].disabled = !unlockConditionForYVZ

	frontCheckboxesMap['YVE_RSQ8'].disabled = !unlockConditionForYVE_RSQ8
	frontCheckboxesMap['YZ1_Q7Q8'].disabled = !unlockConditionForYZ1Q7Q8
	frontCheckboxesMap['YTY'].disabled = !unlockConditionForYTY
}


/**Gets images for all packages depending on selected packages */

function getImages_rsq8(frontCheckboxesMap) {
	for (const checkboxKey in frontCheckboxesMap) {
		//When screen loading
		/*
		const YRB_WAS_MODAL_SELECTED = frontCheckboxesMap['YVJ'].checked && frontCheckboxesMap['YSI'].checked
		const YVN_WAS_MODAL_SELECTED = frontCheckboxesMap['YVJ'].checked && frontCheckboxesMap['YSJ_A6'].checked
		*/
		/*
		if (YRB_WAS_MODAL_SELECTED || YVN_WAS_MODAL_SELECTED) {
			getPackageImages_a6limousine(YRB_WAS_MODAL_SELECTED ? 'YSI-YVJ' : 'YSJ_A6-YVJ', frontCheckboxesMap)
		}else{
			getPackageImages_a6limousine(checkboxKey, frontCheckboxesMap)
		}*/
		getPackageImages_rsq8(checkboxKey, frontCheckboxesMap)
	}
}

function getPackageImages_rsq8(packageCode, checkboxesMap) {
	let specialPackage = '';
	//When in modal
	if (packageCode == 'YSI-YVJ' || packageCode == 'YSJ_A6-YVJ'){
		specialPackage = packageCode
		packageCode = packageCode == 'YSI-YVJ' ? 'YSI' : 'YSJ_A6'
	}

	const checkboxElement = checkboxesMap[packageCode]
	const imageSource = specialPackage != '' ? getPackageImageSource(specialPackage) : getPackageImageSource(packageCode)
	let pressedPackageImg = document.getElementById(specialPackage != ''? specialPackage + '-img' : packageCode + '-img')
	const isChecked = checkboxElement.checked || checkboxElement.parentElement.classList.contains('is-checked')
	//if image does not exist we create it
	if (pressedPackageImg == null) {
		if (!isChecked ) return
		let imageArray = document.querySelector('.image-wrap')
		let newImage = document.createElement('IMG')
		newImage.classList.add('overlay')
		newImage.src = imageSource
		newImage.id = specialPackage != '' ? specialPackage + '-img' : packageCode + '-img'
		imageArray.insertAdjacentElement('beforeend', newImage)
	} else {
		pressedPackageImg.hidden = !isChecked
	}
}


export { addListeners_rsq8, saveStateWithAjax, checkLocks_rsq8, getImages_rsq8, getPackageImages_rsq8, checkSeatsAndSteeringWheelBadges_rsq8}

